import { Box } from '@mui/material';
import React from 'react';
import Container from '../../../layout/Container';
import SpecificOfferSummary from './SpecificOfferSummary';
import { getAssetsBaseUrl } from '../../../config/assetsUrl';

const SpecificOfferHeroSection: React.FC = () => {
    return (
        <Box
            sx={(theme) => ({
                position: "relative",
                backgroundImage: `url(${getAssetsBaseUrl()}/images/background/landingimage4.jpeg)`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                "&::before": {
                    background: "#a4a4a4c0",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    content: '""',
                    ...theme.applyStyles("dark", {
                        background: "#2d2825d9",
                    })
                },
            })}
            width={"100vw"}
            marginLeft={"calc(50% - 50vw)"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            mt={{ xs: 2, md: 4 }}
        >
            <Box maxWidth={1200} width={"100%"} zIndex={2}>
                <Container>
                    <SpecificOfferSummary />
                </Container>
            </Box>
        </Box>
    );
};

export default SpecificOfferHeroSection;
